import { useThemeColor } from '@wistia/vhs';
import type { JSX } from 'react';

export const DisconnectedConnectionIcon = (): JSX.Element => {
  const color = useThemeColor('red500');

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 2C15.6716 2 15 2.67157 15 3.5V11.8498L18 14.8498V3.5C18 2.67157 17.3284 2 16.5 2ZM16.8633 17.9557L15 16.0924V16.5C15 17.3284 15.6716 18 16.5 18C16.6253 18 16.747 17.9846 16.8633 17.9557ZM13.6667 10.5164V7.5C13.6667 6.67157 12.9951 6 12.1667 6C11.3382 6 10.6667 6.67157 10.6667 7.5V7.51642L13.6667 10.5164ZM10.6667 11.7591L13.6667 14.7591V16.5C13.6667 17.3284 12.9951 18 12.1667 18C11.3382 18 10.6667 17.3284 10.6667 16.5V11.7591ZM7.83334 10C7.00492 10 6.33334 10.6716 6.33334 11.5V16.5C6.33334 17.3284 7.00492 18 7.83334 18C8.66177 18 9.33334 17.3284 9.33334 16.5V11.5C9.33334 10.6716 8.66177 10 7.83334 10ZM3.5 14C2.67157 14 2 14.6716 2 15.5V16.5C2 17.3284 2.67157 18 3.5 18C4.32843 18 5 17.3284 5 16.5V15.5C5 14.6716 4.32843 14 3.5 14Z"
        fill={color}
      />
      <rect
        x="2.59769"
        y="6.69006"
        width="3"
        height="18.7558"
        rx="1.5"
        transform="rotate(-45 2.59769 6.69006)"
        fill={color}
      />
    </svg>
  );
};
